module.exports = __webpack_public_path__ + "media/giftcards/GC-HowItWorks-3-9451cab9.svg";